import React, { useEffect, useState } from "react";
import { Button, Table, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import FormularioPaquete from "./FormularioPaquete";
import {API_BASE} from "../../services/apirest";

const AdminPaquetes = () => {
  const [paquetes, setPaquetes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [paqueteSeleccionado, setPaqueteSeleccionado] = useState(null);

  const obtenerPaquetes = async () => {
    try {
        const res = await fetch(`${API_BASE}/paquetes.php`);
      const data = await res.json();
      if (data.status === "success" && data.result.paquetes) {
        setPaquetes(data.result.paquetes);
      } else {
        Swal.fire("Error", "No se pudieron cargar los paquetes", "error");
      }
    } catch (err) {
      console.error("Error al cargar paquetes:", err);
      Swal.fire("Error", "Hubo un problema al conectar con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  const eliminarPaquete = async (id) => {
    const confirmar = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (confirmar.isConfirmed) {
      try {
        const res = await fetch(`${API_BASE}/paquetes.php`, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id })
        });
        const data = await res.json();
        if (data.status === "success") {
          Swal.fire("Eliminado", "El paquete fue eliminado correctamente", "success");
          obtenerPaquetes();
        } else {
          Swal.fire("Error", "No se pudo eliminar el paquete", "error");
        }
      } catch (err) {
        console.error("Error al eliminar paquete:", err);
        Swal.fire("Error", "Error en la conexión al servidor", "error");
      }
    }
  };

  const abrirModal = (paquete = null) => {
    setPaqueteSeleccionado(paquete);
    setShowModal(true);
  };

  const cerrarModal = () => {
    setPaqueteSeleccionado(null);
    setShowModal(false);
    obtenerPaquetes();
  };

  useEffect(() => {
    obtenerPaquetes();
  }, []);

  return (
    <div>
      <h2>Gestión de Paquetes</h2>

      <div className="mb-3">
        <Button variant="success" onClick={() => abrirModal()}>
           Agregar Paquete
        </Button>
      </div>

      {loading ? (
        <p>Cargando paquetes...</p>
      ) : paquetes.length === 0 ? (
        <p>No hay paquetes disponibles.</p>
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nombre del Paquete</th>
              <th>Descripción</th>
              <th>Precio</th>
              <th>Promoción</th>
              <th>Streaming</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {paquetes.map((p) => (
              <tr key={p.id}>
                <td>{p.nombre_paquete}</td>
                <td>{p.descripcion || "-"}</td>
                <td>${p.precio_principal}</td>
                <td>{p.precio_promocion || "-"}</td>
                <td>{p.streaming || "-"}</td>
                <td>
                  <Button
                    variant="primary"
                    size="sm"
                    className="me-2"
                    onClick={() => abrirModal(p)}
                  >
                     Editar
                  </Button>
                  <Button variant="danger" size="sm" onClick={() => eliminarPaquete(p.id)}>
                     Eliminar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <Modal
        show={showModal}
        onHide={cerrarModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {paqueteSeleccionado ? "Editar Paquete" : "Agregar Paquete"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormularioPaquete
            paquete={paqueteSeleccionado}
            onCancelar={cerrarModal}
            onGuardar={cerrarModal}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdminPaquetes;
